<template>
  <div>
    <div class="add-link-title">
      <div class="common-flex" v-if="type !== 3">
        <span class="add-link-span">添加应用市场链接</span>
        <i
          class="el-icon-circle-plus-outline add-link-icon"
          @click="addLink"
          title="添加应用市场链接"
        ></i>
      </div>
    </div>
    <el-row>
      <div v-for="(link, index) in marketLink" :key="index" class="top-flex">
        <div class="link-label">
          <i
            class="el-icon-remove-outline del-link-icon"
            @click="delLink(link)"
            title="删除应用市场链接"
            v-if="type !== 3"
          ></i>
        </div>
        <div class="flex1">
          <el-form
            :model="link"
            :ref="'link_' + index"
            label-width="80px"
            :rules="rules"
          >
            <el-form-item label="应用市场链接" prop="url">
              <el-input
                :disabled="type === 3"
                v-model="link.url"
                placeholder="请填写http://或https://开头的应用市场链接"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ['type'],
  name: 'MarketLink',
  data() {
    // 应用市场链接校验规则
    var validateAdress = (rule, value, callback) => {
      // rule validateAdress 对象
      // value validateAdress 数值
      // callback 回调函数
      const r = /(http|https|HTTP|HTTPS):\/\/([\w.]+\/?)\S*/
      if (value == null || String(value).trim() === '') {
        callback(new Error('请输入应用市场链接'))
      } else if (!r.test(value)) {
        callback(new Error('请填写http://或https://开头的应用市场链接'))
      } else {
        callback()
      }
    }
    return {
      hasEmpty: false,
      marketLink: [], // 应用市场链接列表
      rules: {
        url: [
          { message: '应用市场链接不得为空', trigger: 'blur', required: true },
          { validator: validateAdress, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init(list) {
      if (list === '') {
        this.marketLink = []
      } else {
        const arr = list.split(';')
        this.marketLink = []
        arr.forEach((item, index) => {
          this.$nextTick(() => {
            this.$refs['link_' + index][0].clearValidate()
          })
          const obj = {
            url: item
          }
          this.marketLink.push(obj)
        })
      }
    },
    // 添加应用市场链接
    addLink() {
      if (this.marketLink.length === 15) {
        this.$message.error('应用市场链接不得超过15个')
        return
      }
      const t = new Date().getTime()
      const obj = {
        url: '',
        tid: t
      }
      this.marketLink.push(obj)
    },
    // 删除
    delLink(link) {
      this.marketLink = this.marketLink.filter((item) => item !== link)
    },
    submit() {
      this.hasEmpty = false
      if (this.marketLink.length === 0) {
        return
      }
      for (let i = 0; i < this.marketLink.length; i++) {
        this.$refs['link_' + i][0].validate((valid) => {
          if (!valid) {
            this.hasEmpty = true
          }
        })
        if (this.hasEmpty) {
          break
        }
      }
      return this.hasEmpty
    }
  }
}
</script>

<style lang="scss" scoped>
.add-link-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .add-link-span {
    font-size: 16px;
    margin-right: 10px;
  }
  .add-link-icon {
    font-size: 22px;
    cursor: pointer;
  }
}
.del-link-icon {
  font-size: 22px;
  cursor: pointer;
  margin-right: 5px;
  margin-top: 5px;
}
.link-label {
  width: 150px;
  height: 28px;
  display: flex;
  align-items: center;
}
::v-deep {
  .el-form-item__label {
    line-height: unset;
  }
  .flex1 {
    margin-left: -115px;
    .el-form-item__label {
      width: 120px !important;
      margin-top: 8px !important;
    }
    .el-form-item__content {
      margin-left: 120px !important;
    }
  }
}
</style>
